import { db } from "../../firebaseConfig";
import auth from "../../auth/authService";

import { doc, getDoc, updateDoc, deleteDoc } from "firebase/firestore";

// 🔹 FETCH
export const fetchStockById = async (partnerId, transactionId) => {
    const userId = auth.currentUser.uid;

    const docRef = doc(
        db,
        "users",
        userId,
        "partners",
        partnerId,
        "transactions",
        transactionId
    );

    const snap = await getDoc(docRef);

    if (!snap.exists()) throw new Error("Transaction not found");

    return {
        id: snap.id,
        ...snap.data(),
        partnerId
    };
};

// 🔹 UPDATE
export const updateStock = async (partnerId, transactionId, data) => {
    const userId = auth.currentUser.uid;

    const docRef = doc(
        db,
        "users",
        userId,
        "partners",
        partnerId,
        "transactions",
        transactionId
    );

    await updateDoc(docRef, data);
};

// 🔹 DELETE
export const deleteStockById = async (partnerId, transactionId) => {
    const userId = auth.currentUser.uid;

    const docRef = doc(
        db,
        "users",
        userId,
        "partners",
        partnerId,
        "transactions",
        transactionId
    );

    await deleteDoc(docRef);
};